import { Typography, Grid, Chip } from "@mui/material"
import { labelTitle, subPanelHeader } from "../../../../../assets/styles/appStyles"
import { gridContainer, infoGridItem } from "../../../Styles/CustodianAddressDetailsStyles"
import EntityCustodianDetailsViewModel from "../../../../../Models/custodian/entity-custodian-details-viewmodel";
import CheckboxInput from "../../../../AddLocation/Components/UI/CheckboxInput";

const FollowUpMethodDetails = ({
    custodianDetails,
}: {
    custodianDetails: EntityCustodianDetailsViewModel;
}) => {
    return (
        <>
            <Typography sx={subPanelHeader}>Follow Up Methods</Typography>
            <Grid rowSpacing={3} container sx={gridContainer} spacing={2}>
                <Grid container item rowSpacing={3}>
                    <Grid item xs={6} sx={infoGridItem}>
                        <Typography align="left" sx={labelTitle} mb={'5px'}>
                            Follow Up Methods
                        </Typography>
                        <Grid container spacing={1}>
                            {custodianDetails?.followUpMethods?.map((p) => (
                                <Grid item key={p.id}>
                                    <Chip sx={{ color: 'white' }} label={p.followUpMethodName} color="primary" variant="filled" />
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <CheckboxInput
                            label="Multiple Status Follow Ups"
                            checked={custodianDetails?.servePreferences?.isMultipleStatusFollowUps}
                            keyName={`servePreferences.isMultipleStatusFollowUps`}
                            onChange={(e: any) => { }}
                            onBlur={() => { }}
                            disabled={false}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default FollowUpMethodDetails